import streaming from "./streaming";

export const services = {
  streaming,
};
